
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'JumpWarn',
  components: {}
})
export default class JumpWarn extends Vue {
  visible = false

  showModal () {
    this.visible = true
  }

  sureFunc () {
    this.$router.push({
      path: '/authorize',
    })
  }
}
